// объект сущностей = {
//   сущность_1: {
//     секция_1: [
//       "поле_1",
//       "поля_2",
//     ],
//     секция_2: [
//       "поля_1",
//       "поля_2",
//     ],
//   },
// };

// shifting: "IsProbabilityType", <-- зависимость показа поля от другого поля
// shiftingValue: true,           <-- значение, при котором будет показываться

import { isMaxRateForProbability } from "@/components/loyalty/configs/validationFunctions";

export const advancedParameters = {
  ChargeRuleBaseView: {
    chargeRuleParameters: [
      {
        name: "IsProbabilityType",
        labelsField: "ResultType",
        labelsFieldValue: [[1, 5, 6], [2]],
        labelsValue: ["IsProbabilityType_Bonus", "IsProbabilityType_Discount"],
        column: 1,
        order: 1,
        entityOnly: ["ChargeRuleBaseView"],
        required: ["CalculationType"],
        requiredValue: [[1, 2, 4]],
        shifting: "shiftingValue",
        shiftingValue: "shiftingValue",
      },
      {
        name: "PaymentTypeId",
        required: ["ResultType", "CalculationType", "CalculateFromType"],
        requiredValue: [[1], [2], [30]],
        shifting: "shiftingValue",
        shiftingValue: "shiftingValue",
        order: 1,
        entityOnly: ["ChargeRuleBaseView"],
      },
      {
        name: "Bonus",
        labelsField: "ResultType",
        labelsFieldValue: [
          [1, 5, 6],
          [2],
        ],
        labelsValue: ["IsProbabilityType_Bonus1", "IsProbabilityType_Discount1"],
        entityOnly: ["ChargeRuleBaseView"],
        column: 1,
        order: 2,
        shifting: "IsProbabilityType",
        shiftingValue: true,
      },
      {
        name: "MaxRateForProbabilityType",
        order: 3,
        entityOnly: ["ChargeRuleBaseView"],
        required: ["IsProbabilityType"],
        requiredValue: [[true]],
        validate: ["IsProbabilityType", "ResultType"],
        validateValue: [[true], [1, "1", 2, "2", 5, "5"]],
        validateFunction: isMaxRateForProbability,
        validateFunctionName: "isMaxRateForProbability",
        shifting: "IsProbabilityType",
        shiftingValue: true,
      },
      {
        name: "ChangeStepRateForProbabilityType",
        order: 4,
        column: 1,
        entityOnly: ["ChargeRuleBaseView"],
        required: ["IsProbabilityType"],
        requiredValue: [[true]],
        validate: ["IsProbabilityType", "ResultType"],
        validateValue: [[true], [1, "1", 2, "2", 5, "5"]],
        shifting: "IsProbabilityType",
        shiftingValue: true,
      },
      {
        name: "CalculationType",
        entityOnly: ["ChargeRuleBaseView", "ChargeRuleCounterView", "ChargeRuleStickerView"],
        blockEntity: ["ChargeRuleMessageView", "ChargeRuleCoefficientView"],
        shifting: "IsProbabilityType",
        shiftingValue: true,
        order: 5,
      },
      {
        name: "CalculateFromType",
        label: "chargeRule_CalculateFromType",
        required: ["CalculationType"],
        requiredValue: [
          [2],
        ],
        blockEntity: ["ChargeRuleMessageView", "ChargeRuleCoefficientView"],
        shifting: "IsProbabilityType",
        shiftingValue: true,
        order: 7,
      },
      {
        name: "EntityForCalculationType",
        label: "chargeRule_EntityForCalculationType",
        entityOnly: ["ChargeRuleBaseView", "ChargeRuleSetView", "ChargeRuleCertificateView", "ChargeRuleCounterView", "ChargeRuleMessageView", "ChargeRuleCoefficientView", "ChargeRuleStickerView"],
        order: 8,
        shifting: "IsProbabilityType",
        shiftingValue: true,
      },
      {
        name: "UseConsiderComposition",
        column: 1,
        order: 9,
      },
      {
        name: "NeedToUseConsiderDistribution",
        order:10,
      },
      {
        name: "Rounding",
        order: 11,
      },
      {
        name: "ExternalAccountingType",
        order: 12,
      },
      {
        name: "IsCumulative",
        order: 13,
      },
      {
        name: "CumulativePeriod",
        order: 14,
      },
      {
        name: "FormMCPType",
        order: 15,
      },
      {
        name: "IsOrderUpdateRecalculated",
        order: 16,
      },
      {
        name: "IncludeDAggregation",
        order: 17,
        column: 1,
      },
      {
        name: "EffectExternalDiscountType",
        order: 18,
        column: 2,
      },
    ],
  },
  ChargeRuleCertificateView: {
    chargeRuleParameters: [{
      name: "NeedUseValueFromCoupon",
      order: 1,
    },
    {
      name: "UseConsiderComposition",
      order: 2,
    },
    {
      name: "NeedToUseConsiderDistribution",
      order:3,
    },
    {
      name: "Rounding",
      order: 4,
    },
    {
      name: "ExternalAccountingType",
      order: 5,
    },
    {
      name: "IsCumulative",
      order: 6,
    },
    {
      name: "CumulativePeriod",
      order: 7,
    },
    {
      name: "FormMCPType",
      order: 8,
    },
    {
      name: "IsOrderUpdateRecalculated",
      order: 9,
      required: ["EntityForCalculationType"],
      requiredValue: [[1, 2, 11, 12]],
      shifting: "shiftingValue",
      shiftingValue: "shiftingValue",
    },
    {
      name: "IncludeDAggregation",
      order: 10,
      column: 1,
    },
    {
      name: "EffectExternalDiscountType",
      order: 11,
      column: 2,
    },
    ],
  },
  ChargeRuleSetView: {
    chargeRuleParameters: [{
      name: "UseConsiderComposition",
      order: 1,
    },
    {
      name: "NeedToUseConsiderDistribution",
      order:2,
    },
    {
      name: "CumulativePeriod",
      order: 3,
    },
    {
      name: "IsCumulative",
      order: 4,
    },
    {
      name: "ExternalAccountingType",
      order: 5,
    },
    {
      name: "IsForCoupons",
      column: 1,
      order: 6,
      label: 'ChargeRuleChargeRuleSetView_IsForCoupons',
      shifting: "shiftingValue",
      shiftingValue: "shiftingValue",
    },
    {
      name: "CouponTypeId",
      column: 1,
      order: 7,
      required: ["IsForCoupons"],
      requiredValue: [[true]],
      shifting: "IsForCoupons",
      shiftingValue: true,
    },
    {
      name: "CouponEmissionId",
      column: 2,
      order: 8,
      required: ["IsForCoupons"],
      requiredValue: [[true]],
      shifting: "IsForCoupons",
      shiftingValue: true,
    },
    {
      name: "FormMCPType",
      order: 9,
    },
    {
      name: "IsOrderUpdateRecalculated",
      order: 10,
      required: ["EntityForCalculationType"],
      requiredValue: [[1, 2, 11, 12]],
      shifting: "shiftingValue",
      shiftingValue: "shiftingValue",
    },
    {
      name: "IncludeDAggregation",
      order: 11,
      column: 1,
    },
    {
      name: "EffectExternalDiscountType",
      order: 12,
      column: 2,
    },
    ],
  },
  ChargeRulePersonalCampaignView: {
    chargeRuleParameters: [{
      name: "IsCumulative",
      order: 1,
    },
    {
      name: "CumulativePeriod",
      order: 2,
    },
    {
      name: "ExternalAccountingType",
      order: 3,
    },
    {
      name: "FormMCPType",
      order: 4,
    },
    {
      name: "IsOrderUpdateRecalculated",
      order: 5,
      required: ["EntityForCalculationType"],
      requiredValue: [[1, 2, 11, 12]],
      shifting: "shiftingValue",
      shiftingValue: "shiftingValue",
    },
    {
      name: "IncludeDAggregation",
      order: 6,
      column: 1,
    },
    {
      name: "EffectExternalDiscountType",
      order: 7,
      column: 2,
    },
    ],
  },
  ChargeRuleCommodityCampaignView: {
    chargeRuleParameters: [{
      name: "IsCumulative",
      order: 1,
    },
    {
      name: "CumulativePeriod",
      order: 2,
    },
    {
      name: "IsForCoupons",
      column: 1,
      order: 3,
    },
    {
      name: "CouponTypeId",
      column: 1,
      order: 4,
    },
    {
      name: "CouponEmissionId",
      column: 2,
      order: 5,
    },
    {
      name: "ExternalAccountingType",
      order: 6,
    },
    {
      name: "FormMCPType",
      order: 7,
    },
    {
      name: "IsOrderUpdateRecalculated",
      order: 8,
      required: ["EntityForCalculationType"],
      requiredValue: [[1, 2, 11, 12]],
      shifting: "shiftingValue",
      shiftingValue: "shiftingValue",
    },
    {
      name: "IncludeDAggregation",
      order: 9,
      column: 1,
    },
    {
      name: "EffectExternalDiscountType",
      order: 10,
      column: 2,
    },
    ],
  },
  ChargeRuleCounterView: {
    chargeRuleParameters: [{
      name: "UseConsiderComposition",
      column: 1,
      order: 1,
    },
    {
      name: "Rounding",
      order: 2,
    },
    {
      name: "IsCumulative",
      column: 1,
      order: 3,
    },
    {
      name: "CumulativePeriod",
      order: 4,
    },
    {
      name: "IsOrderUpdateRecalculated",
      order: 5,
      required: ["EntityForCalculationType"],
      requiredValue: [[1, 2, 11, 12]],
      shifting: "shiftingValue",
      shiftingValue: "shiftingValue",
    },
    ],
  },
  ChargeRuleCoefficientView: {
    chargeRuleParameters: [{
      name: "IsForCoupons",
      entityOnly: ["ChargeRuleCoefficientView"],
      column: 1,
      order: 1,
    },
    {
      name: "CouponTypeId",
      column: 1,
      order: 2,
    },
    {
      name: "CouponEmissionId",
      column: 2,
      order: 3,
    },
    ],
  },
  ChargeRuleStickerView: {
    chargeRuleParameters: [{
      name: "UseConsiderComposition",
      order: 1,
    },
    {
      name: "Rounding",
      order: 2,
    },
    {
      name: "IsCumulative",
      order: 3,
    },
    {
      name: "CumulativePeriod",
      order: 4,
    },
    ],
  },
};

// Стартовые состояния для отрисовки свернуто/развернуто ли доп.меню
// "Сущность": {
//    "Атрибут": "Дефолтное значение"
// }

const chargeRuleParameters = {
  Rounding: ["0", 0],
  IsCumulative: ["false", false],
  IsProbabilityType: ["false", false, null],
  UseConsiderComposition: ["false", false],
  IsForCoupons: ["false", false],
  NeedUseValueFromCoupon: ["false", false],
};

export const initialStates = {
  ChargeRuleBaseView: {
    chargeRuleParameters: {
      ...chargeRuleParameters,
      FormMCPType: ["0", 0, null],
    },
  },
  ChargeRuleCertificateView: {
    chargeRuleParameters: {
      Rounding: ["0", 0],
      IsCumulative: ["false", false],
      IsProbabilityType: ["false", false, null],
      UseConsiderComposition: ["false", false],
      NeedUseValueFromCoupon: ["false", false],
      FormMCPType: ["0", 0, null],
    },
  },
  ChargeRuleSetView: {
    chargeRuleParameters: {
      ...chargeRuleParameters,
      FormMCPType: ["0", 0, null],
    },
  },
  ChargeRulePersonalCampaignView: {
    chargeRuleParameters: {
      ...chargeRuleParameters,
      FormMCPType: ["0", 0, null],
    },
  },
  ChargeRuleCommodityCampaignView: {
    chargeRuleParameters: {
      ...chargeRuleParameters,
      FormMCPType: ["0", 0, null],
    },
  },
  ChargeRuleCounterView: {
    chargeRuleParameters,
  },
  ChargeRuleCoefficientView: {
    chargeRuleParameters,
  },
  ChargeRuleStickerView: {
    chargeRuleParameters,
  },
};